import * as Mamba from '@mamba/clients';
import lodash from 'lodash';
import Vue from 'vue';
import { PagesEnum } from './pages';
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe'];
Object.defineProperty(Vue.prototype, '$QueryMerge', {
  get: lodash.constant(function (this: Vue, query: any = '', omit = false) {
    // 关闭
    if (lodash.isString(query) && omit) {
      query = lodash.omit(this.$route.query, query);
    } else if (lodash.isObject(query) && omit) {
      query = lodash.omit(this.$route.query, lodash.keys(query));
    } else {
      if (lodash.isString(query)) {
        query = { [query]: '' };
      }
      query = lodash.merge({}, this.$route.query, query);
    }
    if (lodash.isEqual(this.$route.query, query)) {
      return;
    }
    return this.$router.replace({ query });
  }),
});

Object.defineProperty(Vue.prototype, '$Mamba', {
  get: lodash.constant(Mamba),
});

declare module 'vue/types/vue' {
  interface VueConstructor {
    $Mamba: typeof Mamba;
  }
  interface Vue {
    /**
     * 检查用户是否登录
     * 没有登录会抛异常。try 包裹使用
     * @navigateTo 吊起 登录框
     */
    readonly $InspectUser: (navigateTo?: Boolean) => any;
    readonly $Mamba: typeof Mamba;
    readonly $StatusCode: typeof Mamba.EnumStatusCode;
    /** 创建路由链接地址 */
    readonly $CreatePageUrl: (url: string, query: any) => string;
    /** 给路由中添加参数 */
    readonly $QueryMerge: (query: any, omit?) => any;
  }
}
declare module '@nuxt/types' {
  interface Context {
    readonly $Pages: typeof PagesEnum;
    readonly $StatusCode: typeof Mamba.EnumStatusCode;
  }
}
